<template>
  <div class="cbox-p14 table-main">
    <TableHeader :refTable="refTable" @onRefresh="getTableData()">
      <slot></slot>
    </TableHeader>

    <el-table ref="table" :data="tableData" border stripe height="100%" style="width: 100%" v-loading="tableLoading">
      <el-table-column label="序号" align="center" width="50">
        <template v-slot="{ $index }">
          <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="委托编号" width="160" align="center">
        <template v-slot="{ row }">
          <el-link type="primary" @click="handleProcess(row)">{{ row.reportCodeStart }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="client" label="委托单位" header-align="center" min-width="160"></el-table-column>
      <el-table-column prop="projectName" label="项目名称" header-align="center" min-width="220"></el-table-column>
      <el-table-column prop="sfcn" label="委托单位联系人" align="center" width="110"></el-table-column>
      <el-table-column prop="leaderName" label="项目经理" align="center" width="110"></el-table-column>
      <el-table-column prop="sampleName" label="报告进度" align="center" width="150">
        <template v-slot="{ row }">
          <el-progress
            :stroke-width="8"
            :percentage="Math.round((row.pzNum / row.totalNum) * 100)"
            :format="() => `${row.pzNum}/${row.totalNum}`"
          ></el-progress>
        </template>
      </el-table-column>
      <el-table-column prop="sendDate" label="商定检测日期" align="center" width="120"></el-table-column>

      <el-table-column label="操作" width="100" align="center">
        <template v-slot="{ row }">
          <el-link type="primary" @click="handleDetail(row)">详情</el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page="searchModel.pageNum"
      :page-size="searchModel.pageSize"
      background
      layout="total, prev, sizes ,pager, next, jumper"
      :total="dataTotal"
      @current-change="onCurrentChange"
      @size-change="onSizeChange"
    ></el-pagination>

    <!-- 流程信息 -->
    <ProcessDialog :visible.sync="processVisible" :activeId="activeRowId" />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import ProcessDialog from '@/components/BusinessComponents/ProcessDialog';

import { getEntrustmentSetList } from '@/api/entrust';

export default {
  components: { TableHeader, ProcessDialog },
  props: {
    flowState: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        state: 2,
        keyword: '',
        flowState: 0,
        dateRange: []
      },
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      activeRowId: null,
      activeRowInfo: {},
      editVisible: false,
      processVisible: false,
      returnVisible: false
    };
  },
  computed: {},
  methods: {
    setSearchModel(val) {
      this.searchModel = { ...this.searchModel, ...val };
      this.getTableData(true);
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getEntrustmentSetList({ ...this.searchModel, startTime, endTime, flowState: this.flowState });

      this.dataTotal = data.count;
      this.tableData = data.list || [];

      this.tableLoading = false;
    },
    handleDetail(row) {
      this.$router.push(`/progressDetail/${row.id}`);
    },
    handleProcess(row) {
      this.activeRowId = row.id;
      this.processVisible = true;
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  }
};
</script>
<style lang="scss" scoped>
.link-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>
